import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { c as n } from "../../index-C7ezJk5b.js";
import { G as d } from "../../iconBase-DkR9t2l_.js";
import "../../base-BUIxijjU.js";
import "react";
import { cssX as c } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
function g(i) {
  return d({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" }, child: [] }] })(i);
}
var p = /* @__PURE__ */ ((i) => (i.Switch = "switch", i.Checkbox = "check", i.Radio = "radio", i))(p || {});
const j = ({
  type: i = "switch",
  isChecked: o,
  onChange: e,
  label: t,
  labelPosition: s = "right",
  className: a,
  style: h,
  ...l
}) => /* @__PURE__ */ m(
  "div",
  {
    onClick: e,
    className: n(
      c("Toggle"),
      a,
      `is-${i}`,
      o && "is-checked"
    ),
    ...l,
    style: {
      ...h,
      flexDirection: s === "right" ? "row" : "row-reverse"
    },
    children: [
      /* @__PURE__ */ r("div", { className: c("Toggle__icon"), children: i === "check" && /* @__PURE__ */ r(g, { style: { width: 9, height: 9 } }) }),
      !!t && /* @__PURE__ */ r("div", { className: c("Toggle__label"), children: t })
    ]
  }
);
export {
  p as ToggleType,
  j as default
};
